import React from 'react';

/*
What the artist set list shows, for the shared DataTable.

Sorting is server-side, so only the fields the backend whitelists are marked
sortable.
*/
const artistSetColumns = handleClick => [
  { field: '_id', headerName: 'id', type: 'string', hide: true, isId: true },
  {
    field: null,
    headerName: '',
    type: 'action',
    align: 'left',
    content: rowData => (
      <span
        className="font-icon icon-edit text-20 cursor-pointer"
        title="Edit artist set"
        onClick={() => handleClick('modify', rowData.artistSetSlugName)}
      />
    ),
  },
  { field: 'artistSetName', headerName: 'name', type: 'string', sortable: true, align: 'left' },
  { field: 'artistSetSlugName', headerName: 'slug', type: 'string', sortable: true, align: 'left' },
  { field: 'artistSlugName', headerName: 'artist', type: 'string', sortable: true, align: 'left' },
  { field: 'venueSlugName', headerName: 'venue', type: 'string', sortable: true, align: 'left' },
  { field: 'dateTimeStartReal', headerName: 'starts', type: 'date', align: 'left' },
  { field: 'show', headerName: 'shown', type: 'boolean', align: 'center' },
  { field: 'createdAt', headerName: 'created', type: 'date', sortable: true, align: 'left', description: 'When the record was created' },
  {
    field: null,
    headerName: '',
    type: 'action',
    align: 'right',
    content: rowData => (
      <span
        className="font-icon icon-trash text-20 cursor-pointer"
        title="Delete artist set"
        onClick={() => handleClick('delete', rowData.artistSetSlugName)}
      />
    ),
  },
];

export default artistSetColumns;
